// import { getDefineStyle } from '@mdf/cube/lib/bizmodel/config.js'
// const defineStyleStatue = getDefineStyle()

// comments used by webpack-conditional-loader, do not remove

require('./ys.less')

// 特性开关,写自定义样式针对某个客户
// if (defineStyleStatue?.scrollBarStyle == 'width') {
//   require('./default/define/scrollbar.less')
// }
